import { deleteMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const DELETE_CUSTOMER_PROVIDER = 'DELETE_CUSTOMER_PROVIDER';
export const DELETE_CUSTOMER_PROVIDER_SUCCESS =
  'DELETE_CUSTOMER_PROVIDER_SUCCESS';
export const DELETE_CUSTOMER_PROVIDER_FAILURE =
  'DELETE_CUSTOMER_PROVIDER_FAILURE';

// Action Creators
export const fetchDeleteCustomerProvider = () => ({
  type: DELETE_CUSTOMER_PROVIDER,
});

export const fetchDeleteCustomerProviderSuccess = (data) => ({
  type: DELETE_CUSTOMER_PROVIDER_SUCCESS,
  payload: data,
});

export const fetchDeleteCustomerProviderFailure = (error) => ({
  type: DELETE_CUSTOMER_PROVIDER_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteCustomerProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchDeleteCustomerProvider(data, external));
    try {
      const response = await deleteMethodWithToken(
        url.deleteCustomerSpecialistProviderAdmin + external?.id + '/'
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchDeleteCustomerProviderSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchDeleteCustomerProviderFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchDeleteCustomerProviderFailure(error.message));
    }
  };
};
